// GSTIN client-side validator. Mirrors backend `shared/gstin.py` checksum
// implementation so the customer form can surface "invalid checksum" errors
// at the point of edit, before submission.
const REGEX = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;
const ALPHABET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";

export function gstinChecksumChar(first14) {
    // Same algorithm as the backend: digits are alphabet positions, alternate
    // multipliers 1 and 2, sum mod 36, then 36 minus the modulo.
    let sum = 0;
    for (let i = 0; i < 14; i++) {
        const v = ALPHABET.indexOf(first14[i]);
        if (v < 0) throw new Error(`Invalid GSTIN character at position ${i + 1}: ${first14[i]}`);
        const mult = (i % 2 === 0) ? 1 : 2;
        const prod = v * mult;
        sum += Math.floor(prod / 36) + (prod % 36);
    }
    const checkVal = (36 - (sum % 36)) % 36;
    return ALPHABET[checkVal];
}

export function validateGstin(value) {
    if (!value) return { ok: false, code: "EMPTY", message: "GSTIN is required for business customers." };
    const v = String(value).toUpperCase();
    if (!REGEX.test(v)) {
        return { ok: false, code: "FORMAT", message: "GSTIN must be 15 chars: 2 digits + 5 letters + 4 digits + 1 letter + 1 alnum + Z + 1 alnum." };
    }
    let expected;
    try {
        expected = gstinChecksumChar(v.slice(0, 14));
    } catch (e) {
        return { ok: false, code: "FORMAT", message: e.message };
    }
    if (expected !== v[14]) {
        return {
            ok: false, code: "CHECKSUM",
            message: `Invalid GSTIN checksum — expected '${expected}' as the final character, got '${v[14]}'.`,
        };
    }
    return { ok: true, value: v };
}
